import { ENV } from "../utils";

export class EnvironmentalRiskMatrixform {
  baseApi = ENV.BASE_API;

  async getEnvironmentalRiskMatrix(accessToken, id) {
    try {
      const url = `${this.baseApi}/environmentalriskmatrix/${id}`;
      const params = {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      };
      const response = await fetch(url, params);
      const result = await response.json();

      if (response.status !== 200) throw result;

      return result;
    } catch (error) {
      throw error;
    }
  }

  async createEnvironmentalRiskMatrix(accessToken, data) {
    try {
      const url = `${this.baseApi}/add-environmentalriskmatrix`;
      const params = {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${accessToken}`,
        },
        body: JSON.stringify(data),
      };
      const response = await fetch(url, params);
      const result = await response.json();

      if (response.status !== 200) throw result;

      return result;
    } catch (error) {
      throw error;
    }
  }

  async updateEnvironmentalRiskMatrix(accessToken, id, data) {
    try {
      const url = `${this.baseApi}/environmentalriskmatrix/${id}`;
      const params = {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${accessToken}`,
        },
        body: JSON.stringify(data),
      };
      const response = await fetch(url, params);
      const result = await response.json();

      if (response.status !== 200) throw result;

      return result;
    } catch (error) {
      throw error;
    }
  }

  async deleteEnvironmentalRiskMatrix(accessToken, id) {
    try {
      const url = `${this.baseApi}/delete-environmentalriskmatrix/${id}`;
      const params = {
        method: "DELETE",
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      };
      const response = await fetch(url, params);
      const result = await response.json();

      if (response.status !== 200) throw result;

      return result;
    } catch (error) {
      throw error;
    }
  }

  async getEnvironmentalRiskMatricesBySite(accessToken, site) {
    try {
      const url = `${this.baseApi}/environmentalriskmatrix-site/${site}`;
      const params = {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      };
      const response = await fetch(url, params);
      const result = await response.json();

      if (response.status !== 200) throw result;

      return result;
    } catch (error) {
      throw error;
    }
  }
}
